import { useClientTranslations } from "../../../lib/i18n/client";
import styles from "./EventLegend.module.css";

const LEGEND_ITEMS = [
	{ category: "test-appt", labelKey: "legend.testAppt" },
	{ category: "meds", labelKey: "legend.meds" },
	{ category: "cycle", labelKey: "legend.cycle" },
	{ category: "admin", labelKey: "legend.admin" },
] as const;

export function EventLegend() {
	const { t } = useClientTranslations("track");
	return (
		<ul className={styles.legend}>
			{LEGEND_ITEMS.map((item) => (
				<li key={item.category} className={styles.item}>
					<span
						className={`${styles.chip} ${styles[`chip--${item.category}`]}`}
						aria-hidden="true"
					/>
					<span className={styles.label}>{t(item.labelKey)}</span>
				</li>
			))}
		</ul>
	);
}
